import client from '@/plugins/axios.js'

export default  {
  getTeammembers(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/teammembers')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTeamThisWeek(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/teamThisWeek')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTeamTripdata(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/tripqualforteam')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getAdminTripdata(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/admin/tripqualforadmin')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTeamCampaigndata(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/campaignqualforteam')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTeambonus(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/teambonus')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTeamPerformance(payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/result/teamPerformance/'+payload.week)
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          console.log("service-team : getTeamPerformance - Service call failed",err);
          reject(err)
        })
    });
  },

  getTeamsettings(){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/dealer/teamsettings')
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  setTeamsettings(tsData){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).post('/api/dealer/teamsettings',tsData)
        .then((res)=>{
          resolve(res.data)
        })
        .catch((err)=>{
          reject(err)
        })
    });
  },

  getTopProducts(payload){
      return new Promise((resolve,reject)=>{
        
        client({requiresAuth:true}).get('/api/result/topProductsForWeek/'+payload.week+'/mode/'+payload.mode)
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    },

  getWhoBoughtThat(payload){
      return new Promise((resolve,reject)=>{
        
        client({requiresAuth:true}).get('/api/result/whoBoughtProduct/'+payload.week+'/mode/'+payload.mode+'/artno/'+payload.artno)
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    },


  
  
}
